//
//
//
//
//
//
//

import noData from '~/components/common/noData.vue'
export default {
  name: 'ErrorPage',
  components: {
    'no-data': noData
  },
  layout: 'error',
  head () {
    return {
      title: this.$v('404-WikiFX'),
      meta: [
        { name: 'description', content: this.$v('WikiFX 404') }
      ]
    }
  }
  // mounted () {
  //   console.log('layout/error的自定义错误页')
  // }
}
